// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"efc0bdf9","965":"a81d42f8"}[chunkId] + ".chunk.js";
};